import { ALL_SUITS } from './lookupSuit';
import { ALL_VALUES } from './lookupValue';

const stable = Object.freeze([...ALL_VALUES, ...ALL_SUITS]);

const useAllImagePaths = () => stable;

export default useAllImagePaths;
